import { createContext, useContext } from 'react';
import { GerritInstallationContextValue } from './types';

export const GerritInstallationContext = createContext<
  GerritInstallationContextValue | undefined
>(undefined);

/**
 * Hook to access the Gerrit installation wizard context (the platform
 * installation id + the finalized flag).
 *
 * @throws Error if used outside GerritInstallationContext.Provider
 */
export const useGerritInstallation = () => {
  const context = useContext(GerritInstallationContext);

  if (!context) {
    throw new Error(
      'useGerritInstallation must be used within GerritInstallationContext.Provider',
    );
  }

  return context;
};
